import React, { useState } from 'react';
import axios from 'axios';
import { ThumbsUp, ThumbsDown } from 'lucide-react';
import { useGamification } from '../context/GamificationContext';

const API = `${''}/api`;

// Notation d'une réponse IA (👍/👎 + commentaire) — rapporte des points de contribution.
export const RatingWidget = ({ feature, targetId, className = '' }) => {
  const { notifyResult } = useGamification();
  const [rated, setRated] = useState(null);
  const [showComment, setShowComment] = useState(false);
  const [comment, setComment] = useState('');
  const [busy, setBusy] = useState(false);

  const send = async (rating) => {
    if (busy) return;
    setBusy(true);
    setRated(rating);
    try {
      const res = await axios.post(`${API}/ratings`, { feature, target_id: targetId, rating, comment: comment || null });
      notifyResult?.(res.data);
      if (rating === 'down') setShowComment(true);
    } catch (e) {
      /* silencieux */
    } finally {
      setBusy(false);
    }
  };

  const sendComment = async () => {
    if (!comment.trim()) { setShowComment(false); return; }
    try {
      const res = await axios.post(`${API}/ratings`, { feature, target_id: targetId, rating: rated || 'down', comment });
      notifyResult?.(res.data);
    } catch (e) { /* silencieux */ }
    setShowComment(false);
  };

  return (
    <div className={`flex flex-col gap-2 pt-2 ${className}`} data-testid="rating-widget">
      <div className="flex items-center gap-2 text-xs text-slate-400">
        <span>Cette réponse vous a-t-elle aidé ?</span>
        <button
          data-testid="rate-up"
          onClick={() => send('up')}
          aria-label="Réponse utile"
          className={`p-1.5 rounded-lg transition-all ${rated === 'up' ? 'bg-emerald-500/20 text-emerald-400' : 'text-slate-400 hover:text-emerald-400 hover:bg-emerald-500/10'}`}
        >
          <ThumbsUp className="w-4 h-4" />
        </button>
        <button
          data-testid="rate-down"
          onClick={() => send('down')}
          aria-label="Réponse à améliorer"
          className={`p-1.5 rounded-lg transition-all ${rated === 'down' ? 'bg-rose-500/20 text-rose-400' : 'text-slate-400 hover:text-rose-400 hover:bg-rose-500/10'}`}
        >
          <ThumbsDown className="w-4 h-4" />
        </button>
        {rated && <span className="text-emerald-400/80">Merci pour votre retour !</span>}
      </div>
      {showComment && (
        <div className="flex gap-2">
          <input
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder="Qu'est-ce qui pourrait être amélioré ?"
            className="flex-1 text-sm px-3 py-2 bg-slate-950/50 border border-slate-800 rounded-lg text-slate-200"
            data-testid="rating-comment"
          />
          <button onClick={sendComment} className="px-3 py-2 rounded-lg bg-cyan-600 hover:bg-cyan-500 text-white text-sm" data-testid="rating-comment-send">
            Envoyer
          </button>
        </div>
      )}
    </div>
  );
};
